module.exports = __webpack_public_path__ + "static/media/logo.11b6a949.svg";